
export enum EffectActionEnums {
  // Cog
  LOGOUT = 'LOGOUT',
}
